import flagGermany from '../assets/icons/ic_flag_germany.svg'
import flagEngland from '../assets/icons/ic_flag_england.svg'
import flagFrance from '../assets/icons/ic_flag_france.svg'

export const LANGUAGES = [
  { code: 'de', flag: flagGermany, labelKey: 'german' },
  { code: 'en', flag: flagEngland, labelKey: 'english' },
  { code: 'fr', flag: flagFrance, labelKey: 'french' },
]
